import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "telegram",
  "use": "telegram-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol viewBox=\"0 0 32 32\" xmlns=\"http://www.w3.org/2000/svg\" id=\"telegram\"><g><path d=\"M17.9982 28.0888L13.0796 19.1562L4.14695 14.2376C3.7555 13.9993 3.84036 13.408 4.28305 13.2894L24.6825 6.28263C25.4698 6.0122 26.2235 6.76593 25.9531 7.55324L18.9464 27.9527C18.8278 28.3954 18.2365 28.4803 17.9982 28.0888Z\" stroke-width=\"2\" stroke-linejoin=\"round\" /><path d=\"M13.0789 19.1564L25.6758 6.55957\" stroke-width=\"2\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol